<template>
  <div
    class="c-focusable"
    :style="style"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
    @click="$emit('click', $event)"
  >
    <div :style="contentWrapperStyle">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CFocusable',
  props: {
    showBorder: {
      type: Boolean,
      required: false,
    },
    wrapContent: {
      type: Boolean,
      default: false,
    },
    hasTags: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
      validator(val) {
        return ['small', 'default'].includes(val);
      },
    },
  },
  data() {
    return { hover: false };
  },
  emits: ['click'],
  computed: {
    style() {
      const style = {
        userSelect: 'none',
        transition: 'background 20ms ease-in 0s',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '3px',
        flexGrow: 1,
        padding: '0px 8px',
        fontSize: '14px',
        overflow: 'hidden',
      };
      const middlewares = [this.makeBorder, this.makeBackground, this.makeSize];
      return middlewares.reduce((res, next) => next(res), style);
    },
    contentWrapperStyle() {
      const style = {
        borderRadius: '.4rem',
        display: this.wrapContent ? 'flex' : 'block',
        flexWrap: 'wrap',
        paddingBottom: '0px',
        flexGrow: 1,
      };

      return [this.makePadding].reduce((res, next) => next(res), style);
    },
  },
  methods: {
    makePadding(style) {
      if (!this.hasTags) {
        return style;
      }
      if (this.size === 'small') {
        return {
          ...style,
          paddingTop: '4px',
        };
      }

      return {
        ...style,
        paddingTop: '4px',
      };
    },
    makeSize(style) {
      if (this.size === 'small') {
        return {
          ...style,
          minHeight: '28px',
        };
      }
      return {
        ...style,
        minHeight: '32px',
      };
    },
    makeBackground(style) {
      if (this.hover) {
        return {
          ...style,
          background: this.$colors.grey.lighten7,
        };
      }
      return style;
    },
    makeBorder(style) {
      if (this.showBorder) {
        return {
          ...style,
          boxShadow: 'rgba(15, 15, 15, 0.1) 0px 0px 0px 1px inset',
        };
      }

      return style;
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

</style>
